import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class SharedClickService {
  public triggerSupportClick: Subject<void> = new Subject<void>();

  constructor() { }
}
